// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getOrder } from "@ces/App/Services/OrderService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/LoadOrder";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.apiResult = await getOrder(props.apiParameter);
    } catch (error) {
        if (error.status === 404 || error.status === 403) {
            props.parameter.onError?.(error.errorMessage);
            return;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
